export default __webpack_public_path__ + "assets/images/8abb32715bd23e1e88621fc30b947480.svg";